"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFreeStructuralUnitPositionsForSelect = exports.getFreeStructuralUnitForSelect = exports.getMyEmployee = exports.getMyEmployeesVacancies = exports.getMyEmployees = void 0;
const tslib_1 = require("tslib");
const Api = tslib_1.__importStar(require("api/privateRequest"));
const parsers_1 = require("api/my-space/myEmployees/parsers");
const parsers_2 = require("api/references/structuralUnitsUpgraded/parsers");
const getMyEmployees = async (params) => {
    const response = await Api.get('user/employees', params);
    return (0, parsers_1.parseMyEmployees)(response);
};
exports.getMyEmployees = getMyEmployees;
const getMyEmployeesVacancies = async (params) => {
    const response = await Api.get('user/vacancies', params);
    return (0, parsers_1.parseMyEmployeesVacancies)(response);
};
exports.getMyEmployeesVacancies = getMyEmployeesVacancies;
const getMyEmployee = async (id) => {
    const response = await Api.get('user/employees/' + id);
    return (0, parsers_1.parseMyEmployee)(response);
};
exports.getMyEmployee = getMyEmployee;
const getFreeStructuralUnitForSelect = async (params) => {
    const response = await Api.get('user/employees/units', params);
    return (0, parsers_2.parseStructuralUnitPositionsForSelect)(response);
};
exports.getFreeStructuralUnitForSelect = getFreeStructuralUnitForSelect;
const getFreeStructuralUnitPositionsForSelect = async (params) => {
    const response = await Api.get('user/employees/positions', params);
    return (0, parsers_2.parseStructuralUnitPositionsForSelect)(response);
};
exports.getFreeStructuralUnitPositionsForSelect = getFreeStructuralUnitPositionsForSelect;
